import { Appointment } from '@myapp/contract'
import { calculateBlockRangeFromAppointment, calculateBreakRange } from './blockRanges'

interface Obstacle {
  start: number
  end: number
}

function getObstacles(appointments: Appointment[], breakStartIso?: string): Obstacle[] {
  const obstacles = appointments.map(calculateBlockRangeFromAppointment)
  if (breakStartIso) {
    obstacles.push(calculateBreakRange(breakStartIso))
  }
  return obstacles
}

function findNextAvailableSlot(proposedMs: number, totalMs: number, obstacles: Obstacle[]): number {
  const sorted = [...obstacles].sort((a, b) => a.start - b.start)
  let slotStart = proposedMs

  let changed = true
  while (changed) {
    changed = false
    const slotEnd = slotStart + totalMs
    for (const obs of sorted) {
      if (slotStart < obs.end && slotEnd > obs.start) {
        slotStart = obs.end
        changed = true
        break
      }
    }
  }

  return slotStart
}

function findPrevAvailableSlot(proposedMs: number, totalMs: number, obstacles: Obstacle[]): number {
  const sorted = [...obstacles].sort((a, b) => b.start - a.start)
  let slotStart = proposedMs

  let changed = true
  while (changed) {
    changed = false
    const slotEnd = slotStart + totalMs
    for (const obs of sorted) {
      if (slotStart < obs.end && slotEnd > obs.start) {
        slotStart = obs.start - totalMs
        changed = true
        break
      }
    }
  }

  return slotStart
}

export function findNearestAvailableSlot(
  proposedAnfahrtStartIso: string,
  totalDurationMinutes: number,
  appointments: Appointment[],
  excludeId?: string,
  breakStartIso?: string,
): string {
  const filtered = excludeId ? appointments.filter((a) => a.id !== excludeId) : appointments
  const totalMs = totalDurationMinutes * 60_000
  const proposedMs = new Date(proposedAnfahrtStartIso).getTime()

  const obstacles = getObstacles(filtered, breakStartIso)
  const forwardMs = findNextAvailableSlot(proposedMs, totalMs, obstacles)
  const backwardMs = findPrevAvailableSlot(proposedMs, totalMs, obstacles)

  const nearest =
    Math.abs(forwardMs - proposedMs) <= Math.abs(backwardMs - proposedMs)
      ? forwardMs
      : backwardMs

  return new Date(nearest).toISOString()
}
